import { type AxiosRequestConfig } from 'axios'
import md5 from 'crypto-js/md5'
import { useMessage } from '@/hooks/web/useMessage'

const whiteListSet = new Set() // 防抖接口白名单
const rpcApiUrlList = new Set([])// rpc接口请求拦截白名单
const message = useMessage()

function isObject(obj: any) {
  if(obj == null || obj == undefined) return false
  return obj instanceof Object
}

export const serializeAndSort = (obj: Object) => {
  if (obj == null || typeof obj !== 'object') {
    return JSON.stringify(obj);
  }
  const sortedKeys = Object.keys(obj).sort();
  const pairs = [];
  sortedKeys.forEach(key => {
    if (isObject(obj[key])) {
      pairs.push(`"${key}":${serializeAndSort(obj[key])}`);
    } else {
      pairs.push(`"${key}":"${obj[key]}"`);
    }
  });
  return '{' + pairs.join(',') + '}';
}

export const getRequestKey = (config: AxiosRequestConfig) => {
  if (!config?.url) {
    throw new Error('Request URL is required');
  }
  const { method, url, params, data } = config

  let payload = {}
  if (method.toUpperCase() === 'GET') {
    payload = formatJson(params)
  }
  if (method.toUpperCase() === 'POST') {
    payload = formatJson(data)
    if (params) {
      payload = formatJson(params)
    }
  }

  // 过滤指定参数
  const ignoreFields = ['timestamp', 'nd', 't', '_']
  ignoreFields.forEach(field => {
    if (payload[field]) delete payload[field]
  })
  // 根据url和参数生成唯一key
  let requestKey = md5(`${url}`).toString()
  try {
    if (payload) {
      requestKey = md5(`${url}-${serializeAndSort(payload)}`).toString()
    }
  } catch (error) {
    requestKey = md5(`${url}`).toString()
  }
  // const requestKey = md5(`${url}-${serializeAndSort(payload)}`).toString()

  return requestKey
}

const formatJson = (d: any) => {
  let p = {}
  if (!d) return p
  try {
    p = isObject(d) ? d : { data: JSON.parse(d) }
  } catch (error) {
    p = d
  }
  return p
}

const useDebounceRequest = () => {
  const debounceRequestSet = new Set()

  function isRepeatRequest(config: AxiosRequestConfig) {
    // 白名单跳过检查
    if (whiteListSet.has(config.url)) return false

    const key = getRequestKey(config)
    if (debounceRequestSet.has(key)) return true
    debounceRequestSet.add(key)
    return false
  }

  function onRequestDone(config: AxiosRequestConfig) {
    const md5Key = getRequestKey(config)
    debounceRequestSet.delete(md5Key)
  }

  return {
    isRepeatRequest,
    onRequestDone,
  }
}


const isWhiteListInit = (url: string) => {
  if (rpcApiUrlList.has(url)) {
    return true
  }
  return false
}

// 正在进行中的请求队列
let rcpApiSet: Set<string> = new Set()

export type reqType = {
  url: string
  param?: string,
}

// 生成MD5加密key
const createMD5Key = (req: reqType) => {
  const params = req?.param || {}
  const payload = { ...params }
  const key = serializeAndSort(payload)
  return md5(req.url + key).toString()
}

// 拦截函数
const stopRepeatRequest = (req: reqType) => {
  // client - 当前请求信息,req - 当前请求信息，isWhiteListInit校验当前请求接口是否在白名单里
  const md5Key = createMD5Key(req)
  if (!isWhiteListInit(req.url) && rcpApiSet.has(md5Key)) {
    message.error('请求过于频繁，请稍后再试')
    return 1 //1已有请求
  }
  rcpApiSet.add(md5Key)
  return 2 //初次请求
}

// 清除记录
const allowRequest = (req: reqType) => {
  // req - 当前请求信息
  const md5Key = createMD5Key(req)
  if (rcpApiSet.has(md5Key)) {
    rcpApiSet.delete(md5Key)
  }
}


export {
  useDebounceRequest,
  stopRepeatRequest,
  allowRequest
}  